tasks-schedules-calendar
  .line
    .cell-wrap(each="{cell in this.cells}")
      .month(if="{cell.isShowMonth}") { cell.month }
      .month(if="{!cell.isShowMonth}")
      .day(class="day_{ cell.week }") { cell.day }
      .cell(class="cell_{ cell.week } {today: cell.today}") &nbsp;
  .schedules
    tasks-schedules-cell(each="{id in opts.schedules}" tag-scope="schedule_{id}" base-date="{this.firstDate}")
  script(type="typescript").
    this.mixin('tasks.schedules-calendar')
  style(scoped).
    :scope {
      display: block;
      position: relative;
    }
    .schedules {
      position: absolute;
      top: 0;
      left: 0;
    }
